// Vendor Libs
import React from 'react';

// Components
import CreateRole from '../app/create-role';
import EditRole from '../app/edit-role';
import FlexDashboard from '../core/flex-dashboard';
import Permissions from '../core/permissions';
import Roles from '../search-data/roles';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Roles',
                                component: Roles,
                            },
                        ],
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Create Role',
                        component: CreateRole,
                    },
                    {
                        type: 'tab',
                        name: 'Edit Role',
                        component: EditRole,
                    },
                ],
            },
        ],
    },
};

function DashboardRoles() {
    return (
        <Permissions adminOnly={true} autoRedirect={true}>
            <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="roles" />
        </Permissions>
    );
}

export default DashboardRoles;
